module.exports = new __parcel__URL__("kitten4.37f3cd24.png").toString();